// extracted by mini-css-extract-plugin
export default {"about_page":"AboutPage_about_page__DqwGX","schedule_section":"AboutPage_schedule_section__yBYXb","headingx":"AboutPage_headingx__ox3Lz"};